import classNames from "classnames";
import { IconPinFilled } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";

export const TableHeaderButtons = observer(function TableHeaderButtons(props: {
  onColumnPin: (columnId: string) => void;
  columnID: string;
  locked: boolean;
}) {
  return (
    <div className="group w-full flex space-x-2 absolute px-4 z-10">
      <button
        title="Pin"
        className={classNames(
          "w-[24px] h-[24px] flex justify-center items-center bg-white rounded-md hover:bg-primary-1 cursor-pointer group-hover:opacity-100",
          props.locked && "opacity-100",
          !props.locked && "opacity-0"
        )}
        onClick={() => props.onColumnPin(props.columnID)}
      >
        <IconPinFilled className="w-[12px] " />
      </button>
    </div>
  );
});
